export default __webpack_public_path__ + "static/media/home-white-svg.078c1225.svg";